if (!customElements.get('featured-editorial-vermeillo')) {
  class FeaturedEditorialVermeillo extends HTMLElement {
    constructor() {
      super();
      this.handleSlideChanged = this.handleSlideChanged.bind(this);
    }

    connectedCallback() {
      this.slideshow = this.querySelector('slideshow-component');
      this.cta = this.querySelector('[data-featured-editorial-cta]');
      this.defaultUrl = this.dataset.defaultUrl || '/collections/all';
      this.buttonLabel = this.cta ? this.cta.textContent.trim() : 'Explore';

      if (!this.slideshow || !this.cta) return;

      this.slideshow.addEventListener('slideChanged', this.handleSlideChanged);

      window.requestAnimationFrame(() => {
        this.syncFromSlide(this.getActiveSlide());
      });
    }

    disconnectedCallback() {
      if (!this.slideshow) return;
      this.slideshow.removeEventListener('slideChanged', this.handleSlideChanged);
    }

    handleSlideChanged(event) {
      this.syncFromSlide(event.detail.currentElement);
    }

    getActiveSlide() {
      return this.querySelector('.featured-editorial-vermeillo__slide[aria-hidden="false"]')
        || this.querySelector('.featured-editorial-vermeillo__slide');
    }

    syncFromSlide(slide) {
      if (!slide || !this.cta) return;

      const productUrl = slide.dataset.productUrl || this.defaultUrl;
      const productTitle = slide.dataset.productTitle || 'featured product';

      this.cta.href = productUrl;
      this.cta.setAttribute('aria-label', `${this.buttonLabel} ${productTitle}`);
    }
  }

  customElements.define('featured-editorial-vermeillo', FeaturedEditorialVermeillo);
}
